import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { interval } from 'rxjs';
import { startWith, switchMap, retry } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class VersionCheckService {
    // Check every 5 minutes (300000 ms)
    private checkInterval = 300000;
    private currentHash = '{{POST_BUILD_ENTERS_HASH_HERE}}';

    constructor(private http: HttpClient) { }

    public initVersionCheck(url: string, frequency = this.checkInterval) {
        this.checkVersion(url);

        interval(frequency).pipe(
            startWith(0),
            switchMap(() => this.http.get(url + '?t=' + new Date().getTime())),
            retry(2)
        ).subscribe(
            (response: any) => {
                this.checkHash(response.version);
                console.log('Version Check: ' + response.version);
            },
            (err) => {
                console.error('Could not check version', err);
            }
        );
    }

    /**
     * Will do the call and check if the hash has changed or not
     * @param url
     */
    private checkVersion(url: string) {
        // first interaction
        this.http.get(url + '?t=' + new Date().getTime())
            .pipe(retry(2))
            .subscribe(
                (response: any) => {
                    this.checkHash(response.version);
                },
                (err) => {
                    console.error('Could not get initial version', err);
                }
            );
    }

    /**
     * Checks if hash has changed.
     * If it has, reload the window.
     */
    private checkHash(newHash: string) {
        if (this.currentHash === '{{POST_BUILD_ENTERS_HASH_HERE}}') {
            this.currentHash = newHash;
            return;
        }

        if (this.currentHash !== newHash) {
            console.log('New version detected! Reloading...');
            // Optional: Ask user permission before reloading? For now, auto-reload.
            location.reload();
        }
    }
}
